import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  cart: [],
};

const productsSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    addProductToCart: (state, action) => {
      state.cart.push(action.payload);
    },

    // Remove product from the cart
    removeProductFromCart: (state, action) => {
      state.cart = state.cart.filter(
        (product) => product.item_id !== action.payload.item_id
      );
    },

    deleteCart: (state, action) => {
      state.cart = [];
    },

    // Update product quantity in the cart
    updateProductQuantity: (state, action) => {
      const { item_id, quantity } = action.payload; // Destructure item_id and quantity

      // Create a new cart array with updated quantities
      const updatedCart = state.cart.map((product) => {
        if (product.item_id === item_id) {
          return { ...product, quantity: quantity }; // Update the quantity if it matches
        }
        return product; // Return unchanged product
      });

      // If quantity is 0 or less, filter out the product
      if (quantity <= 0) {
        state.cart = updatedCart.filter(
          (product) => product.item_id !== item_id
        );
      } else {
        state.cart = updatedCart; // Set the updated cart
      }
    },
  },
});

export const {
  addProductToCart,
  removeProductFromCart,
  updateProductQuantity,
  deleteCart,
} = productsSlice.actions;

export default productsSlice.reducer;
